import axios from 'axios';
import { authRefresh } from '../services/endpoints/auth';
import { parseJwt } from '../utils/helper';
import { userLogoutCredentialsAction } from '../redux/actions/user';
// import BC, { REFRESH_ERROR, REFRESH_START, REFRESH_SUCCESS } from '../utils/BroadcastChannel';
import { allRoutes } from './modules';

// eslint-disable-next-line import/no-named-as-default
import store from '../store';
import { IS_LOCAL } from '../utils/config';

let refreshTokenRequestTimer = null;
// let cancelToken = axios.CancelToken.source();
/**
 * @name refreshTokenRecursive
 * @description Функциая постоянного обновление Refresh токена по exp
 * @param isInit {boolean|undefined}
 * @returns {Promise<number>}
 */
export const refreshTokenRecursive = async (isInit) => {
  try {
    if (!isInit) {
      const response = await authRefresh();
      if (!response?.data?.data?.access_token) {
        throw new Error('Access token is missing');
      }
      localStorage?.setItem('access_token', response.data.data.access_token);
    }
    const access_token = localStorage.getItem('access_token');
    if (access_token) {
      const jwt = parseJwt(access_token);
      /**
       * У Супер Админа не будет refresh токена
       */
      if (jwt.su) {
        return;
      }
      if (jwt.exp) {
        const delaySeconds = 10;
        const currentDate = Math.floor(new Date().getTime() / 1000);
        const expSeconds = jwt.exp - currentDate;
        if (expSeconds > delaySeconds) {
          const expSecondsWithDelay = expSeconds - delaySeconds; // Стартуем раньше на 10 секунд
          const expMilliseconds = expSecondsWithDelay * 1000;

          clearTimeout(refreshTokenRequestTimer);
          refreshTokenRequestTimer = setTimeout(() => {
            refreshTokenRecursive(false);
          }, expMilliseconds);

          return expMilliseconds;
        }
      }
    }
  } catch (error) {
    if (axios.isCancel(error)) {
      return;
    }
    store.dispatch(userLogoutCredentialsAction(null));
  }
};

export const refreshTokenRecursiveClear = () => clearTimeout(refreshTokenRequestTimer);

/**
 * @name getAccessRoutes
 * @description Список React роутов после фильтра access из navbar
 * @returns {*[]}
 */
export const getAccessRoutes = () => {
  const {
    header: { access, routes, accessRoutes },
  } = store.getState();

  const access_token = localStorage.getItem('access_token');
  const jwt = parseJwt(access_token);

  const routesRevert = Object.keys(routes).reduce((accumulator, currentValue) => {
    accumulator[routes[currentValue]] = currentValue;
    return accumulator;
  }, {});
  return allRoutes.filter((route) => {
    if (route.public || route.super_admin) {
      return false;
    }
    if (route?.su && !IS_LOCAL) {
      return !!jwt?.su;
    }
    if (route.link === '/guides') {
      return true;
    }
    if ((routesRevert[route.link] && access[routesRevert[route.link]]) || accessRoutes?.find((r) => r.code === routesRevert[route.link])) {
      return true;
    }
    return false;
  });
};
